<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem">
				<span class="label">总计：</span>
				<span class="price">￥{{money}}</span>
			</span>
			<span class="priceItem">
				<span class="label">会员价：</span>
				<span class="price">￥{{vipMoney}}</span>
			</span>
			<span class="priceItem">
				<span class="label">优惠金额：</span>
				<span class="price">￥{{$public.jian(money,activityMoney)}}</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right: 20px;">
				<span class="label">应付金额：</span>
				<span class="price"  style="color:#FF2F2F;">￥{{activityMoney}}</span>
			</span>
			<span v-if="false">
				<dialogDiscountCard :arr="saleList" :userInfo="{_id:userInfo._id}" @submit="submitCard"></dialogDiscountCard>
			</span>
			<el-button style="width:80px;" type="warning" plain @click="openBeizhu" size="small">备注</el-button>
			<el-button style="width:100px;" type="warning" @click="submitOrder" size="small">创建寄养</el-button>
			<!-- <el-button style="width:80px;" type="primary" plain @click="submitOrderAndSettlement">结算</el-button> -->
		</div>
		<!-- 备注弹窗 -->
		<!-- <el-dialog :title="''" :visible.sync="dialog_beizhu_state" width="500px" :show-close="false" :modal-append-to-body="false">
			<div >
				<div style="display: flex;">
					<div style="line-height: 35px;padding:0 0px 0 20px;">备注：</div>
					<el-input style="width:380px;" type="textarea" rows="5" v-model="remark_pre" placeholder="请输入备注"></el-input>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialog_beizhu_close">取 消</el-button>
				<el-button type="primary" @click="dialog_beizhu_submit">确 定</el-button>
			</div>
		</el-dialog> -->
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'jiyang'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogDiscountCard from "../../../../components/dialog_discount_card.vue"
	import drawerRemark from "../drawer/remark.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	import del from "../../../../util/del.js"
	export default {
		components:{dialogDiscountCard,drawerRemark,dialogSettlement},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
				// 
				o:null,
				// 是否直接结算
				direct:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			curDiscountCard(){
				return this.$store.state.mendian.curDiscountCard;
			},
			saleList(){
				return this.$store.state.mendian.saleList;
			},
			addParams(){
				return this.$store.state.jiyang.addParams;
			},
			vipMoney(){
				return this.$store.state.jiyang.vipMoney;
			},
			money(){
				return this.$store.state.jiyang.money;
			},
			activityMoney(){
				return this.$store.state.jiyang.activityMoney;
			},
			remark(){
				return this.$store.state.jiyang.remark;
			},
		},
		mounted(){
			this.o = new del();
		},
		methods:{
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 创建订单
			submitOrder(){
				console.log('addParams',this.addParams)
				// if(!this.addParams.handlerId){
				// 	this.$message({
				// 		message: '请选择经办人',
				// 		type: 'error'
				// 	});
				// 	return ;
				// }
				// if(this.addParams.depositType!==2){
				// 	if(!(Number(this.addParams.deposit)>0)){
				// 		this.$message({
				// 			message: '请输入押金金额',
				// 			type: 'error'
				// 		});
				// 		return ;
				// 	}
				// }
				if(this.addParams.pets_list==undefined||this.addParams.pets_list.length===0){
					this.$message({
						message: '请添加宠物',
						type: 'error'
					});
					return ;
				}
				let pets = []
				for(let i=0;i<this.addParams.pets_list.length;i++){
					let obj = this.addParams.pets_list[i];
					if(obj.petId){
						if(!obj.startTime){
							this.$message({
								message: '请选择寄养开始时间',
								type: 'error'
							});
							return ;
						}
						if(!obj.endTime){
							this.$message({
								message: '请选择寄养结束时间',
								type: 'error'
							});
							return ;
						}
						if(!obj.serviceId){
							this.$message({
								message: '请选择寄养服务',
								type: 'error'
							});
							return ;
						}
						// if(!obj.cageInfo.cageId){
						// 	this.$message({
						// 		message: '请选择笼子',
						// 		type: 'error'
						// 	});
						// 	return ;
						// }
						let cages = [];
						for(let a=0;a<obj.roomIds.length;a++){
							let aa = obj.roomIds[a].split(',')
							cages.push({id:aa[0],name:aa[1]})
						}
						let curPet = obj.petItem;
						pets.push({
							"petId": obj.petId,
							"petName": curPet.nick_name,
							"classType": curPet.apply_type.value,
							"className": curPet.apply_type.title,
							"typeName": curPet.category_info.name,
							"sex": curPet.pet_sex,
							"weight": curPet.weight,
							"birthDay": curPet.bron_date,
							"beginDate": (new Date(obj.startTime).getTime()).toString().substr(0,10),
							"endDate": (new Date(obj.endTime).getTime()).toString().substr(0,10),
							// "activityId": obj.activityId,
							// "activityName": obj.activityId?obj.activityItem.name:'',
							"serviceId": obj.serviceItem.serviceId,
							"serviceObjectId": obj.skuItem.service_objectId,
							"categoryId": obj.serviceItem.category_info._id,
							"categoryName": obj.serviceItem.category_info.name,
							"servicePrice": obj.activityPrice,
							"serviceVipPrice":obj.mprice,
							"remark": obj.remark,
							roomId:obj.roomId,
							cageInfo: obj.cageInfo,
						})
					}
				}
				let petsId = []
				for(let i=0;i<pets.length;i++){
					if(petsId.indexOf(pets[i].petId)>-1){
						this.$message({
							message: '每只宠物只能寄养一次',
							type: 'error'
						});
						return ;
					}
					petsId.push(pets[i].petId)
				}
				// let salesMans = []
				// for(let i=0;i<this.addParams.handlerId.length;i++){
				// 	let arr = this.addParams.handlerId[i].split(',')
				// 	salesMans.push({"userId": arr[0],"userName": arr[1]})
				// }
				let params = {
					"pets": pets,
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"memberGrades": this.userInfo.club_card. surplus_day,
					"depositType": this.addParams.depositType||1,
					// "deposit": Number(this.addParams.deposit)||0,
					// "payType": this.addParams.payType||0,
					"deposit": 0,
					"payType": 0,
					// "serviceMan": salesMans,
					"remark": this.remark,
					"contactName": this.userInfo.basic_info.urgent_user||'',
					"contactMobile": this.userInfo.basic_info.urgent_user_mobile||'',
					"autoDeduct": this.addParams.autoDeduct||false,
				}
				console.log(params,"params")
				let loading = this.$loading()
				this.$http.post('/api/FosterCare/Insert', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(this.direct){
							this.curOrder = res.data;
							this.dialogSettlement_state = true;
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('jiyang/set_type','list')
							this.$store.dispatch('mendian/getJiedaiLength')
						}
					}
				})
			},
			// 优惠券
			submitCard(card){
				if(card!=='close'){
					this.$store.commit('mendian/set_curDiscountCard',card)
				}
			},
			// 结算
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
				}
				this.$store.commit('jiyang/set_type','list')
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 3px 0px #f5f5f5;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
